import baoRouter from "./../../services/bao-router";
window.UadmApplicationId = "ebfac8b4-3cac-4a08-8ff9-fdda06ce61d5";
const Routes = {
    "uadm/search": {
        url: "Search",
        objectId: "Search",
        closable: false
    },
    "uadm/role": {
        url: "Uadm/Role",
        replaceRoute: "uadm/role/{id}"
    },
    "uadm/role/{id}": {
        url: "Uadm/Role"
    },
    "uadm/user": {
        url: "Uadm/User",
        replaceRoute: "uadm/user/{id}"
    },
    "uadm/user/{id}": {
        url: "Uadm/User"
    },
    "uadm/securitypolicy": {
        url: "Uadm/SecurityPolicy",
        objectId: "SecurityPolicy"
    },
    "uadm/MyApps": {
        url: "Uadm/MyApps",
        objectId: "MyApps"
    }
};
baoRouter.addRoutes(Routes);
export default Routes;